import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { changePassword } from "../../../../redux/zservices/BasicAPIFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { notallowspace } from "../../../Common/FewCommonMethods";
import { passwordvalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const validationSchema = Yup.object().shape({
  password: passwordvalidation,
  conformpassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .test("not-only-spaces", "Please enter a valid value", (value) => {
      return value.trim().length > 7;
    }),
});

export default function ResetPassword({ valuess }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const navigate = useNavigate();
  const path = "Assets/scss/FirstTimeUsers.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const initialValues = {
    email_id: valuess?.email_id,
    password: "",
    conformpassword: "",
  };

  const handleSubmit = (values) => {
    const body = {
      email_id: valuess?.email_id,
      password: values.password,
    };
    changePassword(body)
      .then((res) => {
        if (res.data.status) {
          navigate(`/${lan}/loginwithemail`);
          urtoast(`Password Updated Successfully`, 1);
          LogoutMethod()
        } else if (!res.data.status) {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(`error in login with password`, 2);
      });
  };

  const LogoutMethod = () => {
    localStorage.removeItem("urexperttoken");
    localStorage.removeItem("role_type");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("urlState");
    // navigate(`/${lan}/`);
    window.location.reload()
  };


  return (
    <div className="mx-auto register ">
      <h1 className="heading">Reset password</h1>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Please Reset password.
      </p>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            { }
            <div className="col-md-8 mx-auto form-sec login-email">
              <div className="row">
                <div className="col-md-12 form-group">
                  <label htmlFor="password">Password <AsteriskLabel /></label>
                  <div className="password-btn">
                    <Field
                      onKeyDown={notallowspace}
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      placeholder="Password (8 or more characters)"
                    />
                    <span onClick={togglePasswordVisibility} className="btn">
                      {showPassword ? (
                        <i className="fa-solid fa-eye" aria-hidden="true"></i>
                      ) : (
                        <i className="fa-solid fa-eye-slash"></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error"
                  />
                </div>
                <div className="col-md-12 form-group">
                  <label htmlFor="conformpassword">Confirm Password <AsteriskLabel /></label>
                  <div className="password-btn">
                    <Field
                      onKeyDown={notallowspace}
                      type={showPassword1 ? "text" : "password"}
                      id="conformpassword"
                      name="conformpassword"
                      className="form-control"
                      placeholder="Confirm Password"
                    />
                    <span onClick={togglePasswordVisibility1} className="btn">
                      {showPassword1 ? (
                        <i className="fa-solid fa-eye" aria-hidden="true"></i>
                      ) : (
                        <i className="fa-solid fa-eye-slash"></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage
                    name="conformpassword"
                    component="div"
                    className="error"
                  />
                </div>
                <div className="col-md-12 last-form">
                  <button type="submit" className="btn create-account">
                    Confirm & change password
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
